import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getDocumentos, createDocumento, deleteDocumento, updateDocumento, getComunidades, getUploadUrl, anadirPropietariosEmails, getPropietariosExternos, deletePropietarioExterno, enviarDocumentoPropietarios } from '../services/api';
import { useToast } from '../components/Toast';
import Pagination from '../components/Pagination';
import DateInput from '../components/DateInput';
import Button from '../components/ui/Button';
import EmptyState from '../components/EmptyState';
import ConfirmModal from '../components/ConfirmModal';
import './Documentos.css';

function Documentos() {
  const toast = useToast();
  const location = useLocation();
  const [documentos, setDocumentos] = useState([]);
  const [documentosFiltrados, setDocumentosFiltrados] = useState([]);
  const [comunidades, setComunidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [bulkFiles, setBulkFiles] = useState([]);
  const [bulkComunidadId, setBulkComunidadId] = useState('');
  const [bulkProgress, setBulkProgress] = useState(null); // { current, total, errors }
  const [user, setUser] = useState(null);
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [filtroComunidad, setFiltroComunidad] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [confirmModal, setConfirmModal] = useState({ isOpen: false, title: '', message: '', onConfirm: null });
  const [showPropietariosModal, setShowPropietariosModal] = useState(false);
  const [propietariosComunidadId, setPropietariosComunidadId] = useState('');
  const [propietariosLista, setPropietariosLista] = useState([]);
  const [loadingPropietarios, setLoadingPropietarios] = useState(false);
  const [emailInput, setEmailInput] = useState('');
  const [emailsBulk, setEmailsBulk] = useState('');
  const [loadingAnadir, setLoadingAnadir] = useState(false);
  const [docParaPreview, setDocParaPreview] = useState(null);
  const [previewBlobUrl, setPreviewBlobUrl] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [docParaEditar, setDocParaEditar] = useState(null);
  const [editNombre, setEditNombre] = useState('');
  const [editDescripcion, setEditDescripcion] = useState('');
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [docParaEnviar, setDocParaEnviar] = useState(null);
  const [loadingEnvio, setLoadingEnvio] = useState(false);
  const [resultadoEnvio, setResultadoEnvio] = useState(null);
  const [nuevoDoc, setNuevoDoc] = useState({    nombre: '',
    descripcion: '',
    categoria: 'acta',
    comunidad_id: '',
    archivo: null
  });

  const categorias = {
    acta: { label: 'Actas', color: '#3b82f6', icon: '📋' },
    balance: { label: 'Balances e informes contables', color: '#10b981', icon: '💰' },
    documentacion_finca: { label: 'Documentación de la finca', color: '#6366f1', icon: '🏢' },
    inspeccion: { label: 'Inspecciones', color: '#f59e0b', icon: '🔍' },
    proveedor: { label: 'Proveedores', color: '#a855f7', icon: '🔧' },
    otro: { label: 'Otros', color: '#9ca3af', icon: '📎' }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const comunidadParam = params.get('comunidad_id');
    if (comunidadParam) setFiltroComunidad(comunidadParam);

    const userStr = localStorage.getItem('user');
    if (userStr) {
      const userData = JSON.parse(userStr);
      setUser(userData);
      if (userData.rol === 'administrador') {
        cargarComunidades();
      }
    }
    cargarDocumentos();
  }, []);

  useEffect(() => {
    aplicarFiltros();
  }, [documentos, filtroCategoria, busqueda, fechaDesde, fechaHasta, filtroComunidad]);

  const cargarDocumentos = async () => {
    try {
      const response = await getDocumentos();
      setDocumentos(response.data);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al cargar documentos');
    } finally {
      setLoading(false);
    }
  };

  const aplicarFiltros = () => {
    let resultado = [...documentos];

    // Filtro por categoría
    if (filtroCategoria) {
      resultado = resultado.filter(doc => doc.categoria === filtroCategoria);
    }

    // Filtro por búsqueda
    if (busqueda) {
      const busquedaLower = busqueda.toLowerCase();
      resultado = resultado.filter(doc =>
        doc.nombre.toLowerCase().includes(busquedaLower) ||
        (doc.descripcion && doc.descripcion.toLowerCase().includes(busquedaLower))
      );
    }

    if (fechaDesde) {
      const fechaDesdeValue = new Date(fechaDesde);
      resultado = resultado.filter(doc => new Date(doc.fecha_subida || doc.fecha_creacion) >= fechaDesdeValue);
    }

    if (fechaHasta) {
      const fechaHastaValue = new Date(fechaHasta);
      fechaHastaValue.setHours(23, 59, 59, 999);
      resultado = resultado.filter(doc => new Date(doc.fecha_subida || doc.fecha_creacion) <= fechaHastaValue);
    }

    // Filtro por comunidad (solo admin)
    if (filtroComunidad) {
      resultado = resultado.filter(doc => String(doc.comunidad_id) === String(filtroComunidad));
    }

    setDocumentosFiltrados(resultado);
    setCurrentPage(1);
  };

  const cargarComunidades = async () => {
    try {
      const response = await getComunidades();
      setComunidades(response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const openConfirm = (title, message, onConfirm) => {
    setConfirmModal({ isOpen: true, title, message, onConfirm });
  };
  const closeConfirm = () => setConfirmModal(prev => ({ ...prev, isOpen: false }));

  const handleOpenModal = () => {
    const preselect = filtroComunidad || (comunidades.length === 1 ? String(comunidades[0].id) : '');
    setNuevoDoc({ nombre: '', descripcion: '', categoria: 'acta', comunidad_id: preselect, archivo: null });
    setShowModal(true);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nuevoDoc.nombre || !nuevoDoc.archivo) {
      toast.error('Por favor completa los campos requeridos');
      return;
    }
    if (user?.rol === 'administrador' && !nuevoDoc.comunidad_id) {
      toast.error('Debes seleccionar una comunidad');
      return;
    }

    setLoadingSave(true);
    try {
      const data = new FormData();
      data.append('nombre', nuevoDoc.nombre);
      data.append('descripcion', nuevoDoc.descripcion);
      data.append('categoria', nuevoDoc.categoria);
      if (user?.rol === 'administrador') {
        data.append('comunidad_id', nuevoDoc.comunidad_id);
      }
      data.append('archivo', nuevoDoc.archivo);

      await createDocumento(data);
      toast.success('Documento subido con éxito');
      setShowModal(false);
      setNuevoDoc({ nombre: '', descripcion: '', categoria: 'acta', comunidad_id: '', archivo: null });
      cargarDocumentos();
    } catch (error) {
      toast.error('Error: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoadingSave(false);
    }
  };

  const handleBulkFileChange = (e) => {
    const files = Array.from(e.target.files).filter(f => {
      // Ignorar ficheros ocultos del sistema (._DS_Store, Thumbs.db, etc.)
      const name = f.name;
      return !name.startsWith('.') && name !== 'Thumbs.db' && name !== 'desktop.ini';
    });
    setBulkFiles(prev => {
      // Si ya hay archivos seleccionados, añadir los nuevos (sin duplicados por nombre)
      const existingNames = new Set(prev.map(f => f.archivo.name + f.archivo.size));
      const nuevos = files
        .filter(f => !existingNames.has(f.name + f.size))
        .map(f => ({
          archivo: f,
          nombre: f.name.replace(/\.[^/.]+$/, ''),
          categoria: 'acta',
        }));
      return [...prev, ...nuevos];
    });
    setBulkProgress(null);
    // Limpiar el input para permitir volver a seleccionar la misma carpeta
    e.target.value = '';
  };

  const updateBulkFile = (index, field, value) => {
    setBulkFiles(prev => prev.map((f, i) => i === index ? { ...f, [field]: value } : f));
  };

  const removeBulkFile = (index) => {
    setBulkFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleBulkSubmit = async () => {
    if (bulkFiles.length === 0) return;
    if (user?.rol === 'administrador' && !bulkComunidadId) {
      toast.error('Selecciona una comunidad para todos los documentos');
      return;
    }
    const total = bulkFiles.length;
    const errors = [];
    setBulkProgress({ current: 0, total, errors: [] });

    for (let i = 0; i < bulkFiles.length; i++) {
      const item = bulkFiles[i];
      try {
        // Validar tamaño antes de enviar (200MB)
        if (item.archivo.size > 209715200) {
          errors.push({ nombre: item.nombre, motivo: 'supera 200 MB' });
          setBulkProgress({ current: i + 1, total, errors: [...errors] });
          continue;
        }
        const data = new FormData();
        data.append('nombre', item.nombre);
        data.append('descripcion', '');
        data.append('categoria', item.categoria);
        if (user?.rol === 'administrador') data.append('comunidad_id', bulkComunidadId);
        data.append('archivo', item.archivo);
        await createDocumento(data);
      } catch (err) {
        const status = err.response?.status;
        const motivo = status === 413 ? 'archivo demasiado grande'
          : status === 400 ? (err.response?.data?.error || 'formato no permitido')
          : 'error del servidor';
        errors.push({ nombre: item.nombre, motivo });
      }
      setBulkProgress({ current: i + 1, total, errors: [...errors] });
    }

    const ok = total - errors.length;
    if (errors.length === 0) {
      toast.success(`${total} documento${total > 1 ? 's' : ''} subido${total > 1 ? 's' : ''} correctamente`);
    } else {
      toast.error(`${ok} subido${ok !== 1 ? 's' : ''}, ${errors.length} con error`);
    }
    cargarDocumentos();
    setTimeout(() => {
      if (errors.length === 0) {
        setShowBulkModal(false);
        setBulkFiles([]);
        setBulkComunidadId('');
        setBulkProgress(null);
      }
    }, 1500);
  };

  const handleEliminar = (id) => {
    openConfirm(
      'Eliminar documento',
      '¿Estás seguro de que quieres eliminar este documento? Esta acción no se puede deshacer.',
      () => {
        closeConfirm();
        deleteDocumento(id)
          .then(() => {
            toast.success('Documento eliminado con éxito');
            cargarDocumentos();
          })
          .catch(() => {
            toast.error('Error al eliminar documento');
          });
      }
    );
  };

  const handleDownload = (doc) => {
    try {
      const link = document.createElement('a');
      link.href = getUploadUrl(doc.archivo);
      link.download = doc.nombre || doc.archivo.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success('Descarga iniciada');
    } catch (error) {
      toast.error('Error al descargar documento');
    }
  };

  const formatBytes = (bytes) => {
    if (!bytes) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const totalPages = Math.ceil(documentosFiltrados.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const documentosFiltradosPaginados = documentosFiltrados.slice(indexOfFirstItem, indexOfLastItem);
  const getCategoriaLabel = (categoria) => {
    return categorias[categoria]?.label || categoria;
  };

  const getFileMeta = (doc) => {
    const fileName = (doc.archivo || doc.nombre || '').toLowerCase();
    const ext = fileName.includes('.') ? fileName.split('.').pop() : '';
    if (['pdf'].includes(ext)) return { label: 'PDF', kind: 'pdf' };
    if (['doc', 'docx'].includes(ext)) return { label: 'WORD', kind: 'word' };
    if (['xls', 'xlsx', 'csv'].includes(ext)) return { label: 'EXCEL', kind: 'excel' };
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return { label: 'IMG', kind: 'image' };
    return { label: 'FILE', kind: 'file' };
  };

  const esNuevo = (fecha) => {
    if (!fecha) return false;
    const fechaDoc = new Date(fecha);
    if (Number.isNaN(fechaDoc.getTime())) return false;
    const diff = Date.now() - fechaDoc.getTime();
    return diff <= 7 * 24 * 60 * 60 * 1000;
  };

  const abrirPreview = async (doc) => {
    setDocParaPreview(doc);
    setPreviewBlobUrl(null);
    setLoadingPreview(true);
    window.history.pushState({ previewModal: true }, '');
    try {
      const resp = await import('axios').then(m => m.default.get(getUploadUrl(doc.archivo), { responseType: 'blob' }));
      const url = URL.createObjectURL(resp.data);
      setPreviewBlobUrl(url);
    } catch {
      toast.error('No se pudo cargar la vista previa');
    } finally {
      setLoadingPreview(false);
    }
  };

  const cerrarPreview = () => {
    if (previewBlobUrl) URL.revokeObjectURL(previewBlobUrl);
    setDocParaPreview(null);
    setPreviewBlobUrl(null);
  };

  // Cerrar modal con botón atrás del navegador/móvil
  useEffect(() => {
    const handlePopState = () => {
      if (docParaPreview) cerrarPreview();
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [docParaPreview, previewBlobUrl]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleGuardarEdicion = async () => {
    if (!editNombre.trim() || !docParaEditar) return;
    setLoadingEdit(true);
    try {
      await updateDocumento(docParaEditar.id, { nombre: editNombre.trim(), descripcion: editDescripcion.trim() });
      toast.success('Nombre actualizado');
      setDocParaEditar(null);
      cargarDocumentos();
    } catch {
      toast.error('Error al actualizar el documento');
    } finally {
      setLoadingEdit(false);
    }
  };

  const cargarPropietarios = async (comunidad_id) => {
    if (!comunidad_id) { setPropietariosLista([]); return; }
    setLoadingPropietarios(true);
    try {
      const resp = await getPropietariosExternos(comunidad_id);
      setPropietariosLista(resp.data);
    } catch {
      toast.error('Error al cargar propietarios');
    } finally {
      setLoadingPropietarios(false);
    }
  };

  const handleAnadirEmails = async (emails) => {
    if (!emails.length || !propietariosComunidadId) return;
    setLoadingAnadir(true);
    try {
      const resp = await anadirPropietariosEmails(propietariosComunidadId, emails);
      const { insertados, errores } = resp.data;
      if (insertados > 0) toast.success(`${insertados} email${insertados !== 1 ? 's' : ''} añadido${insertados !== 1 ? 's' : ''}`);
      if (errores > 0) toast.error(`${errores} email${errores !== 1 ? 's' : ''} con formato inválido`);
      await cargarPropietarios(propietariosComunidadId);
    } catch {
      toast.error('Error al añadir propietarios');
    } finally {
      setLoadingAnadir(false);
    }
  };

  const handleAnadirUno = async () => {
    const email = emailInput.trim();
    if (!email) return;
    await handleAnadirEmails([email]);
    setEmailInput('');
  };

  const handleAnadirBulk = async () => {
    const emails = emailsBulk.split(/[\n,;]+/).map(e => e.trim()).filter(Boolean);
    if (!emails.length) return;
    await handleAnadirEmails(emails);
    setEmailsBulk('');
  };

  const handleEliminarPropietario = async (id) => {
    try {
      await deletePropietarioExterno(id);
      setPropietariosLista(prev => prev.filter(p => p.id !== id));
    } catch {
      toast.error('Error al eliminar propietario');
    }
  };

  const handleEnviarDocumento = async () => {
    if (!docParaEnviar) return;
    setLoadingEnvio(true);
    setResultadoEnvio(null);
    try {
      const resp = await enviarDocumentoPropietarios(docParaEnviar.id);
      setResultadoEnvio(resp.data);
    } catch {
      toast.error('Error al enviar el documento');
    } finally {
      setLoadingEnvio(false);
    }
  };

  const categoriasEnDatos = Array.from(new Set(documentos.map((doc) => doc.categoria).filter(Boolean)));
  const mostrarCategorias = categoriasEnDatos.length > 0;

  return (
    <div className="documentos-page">
      <header className="documentos-header">
        <div>
          <h1 className="documentos-title">📁 Documentos</h1>
          <p className="documentos-subtitle">Actas, normativa y archivos de la comunidad</p>
        </div>
        <div className="documentos-header-actions">
          <span className="documentos-count">{documentos.length} documentos</span>
          {user?.rol === 'administrador' && (
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <Button variant="secondary" size="md" onClick={() => { setPropietariosComunidadId(''); setPropietariosLista([]); setEmailInput(''); setEmailsBulk(''); setShowPropietariosModal(true); }}>
                Propietarios ext.
              </Button>
              <Button variant="secondary" size="md" onClick={() => { setBulkFiles([]); setBulkProgress(null); setShowBulkModal(true); }}>
                Subida masiva
              </Button>
              <Button variant="primary" size="md" onClick={handleOpenModal}>
                Subir documento
              </Button>
            </div>
          )}
        </div>
      </header>

      <section className="documentos-toolbar">
        <div className="documentos-search">
          <span className="documentos-search-icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </span>
          <input
            type="text"
            className="form-control documentos-search-input"
            placeholder="Buscar documento..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>
        <div className="documentos-filter-row">
          <div className="documentos-filter">
            <label className="form-label">Tipo</label>
            <select
              className="form-control"
              value={filtroCategoria}
              onChange={(e) => setFiltroCategoria(e.target.value)}
            >
              <option value="">Todos</option>
              {Object.entries(categorias).map(([key, cat]) => (
                <option key={key} value={key}>{cat.icon} {cat.label}</option>
              ))}
            </select>
          </div>
          <button
            className="documentos-advanced-toggle"
            onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
          >
            {showAdvancedFilters ? 'Basico' : 'Mas filtros'}
          </button>
        </div>

        {showAdvancedFilters && (
          <div className="documentos-advanced-filters">
            <div className="documentos-filter-dates">
              <div className="documentos-filter">
                <label className="form-label">Desde</label>
                <DateInput
                  value={fechaDesde}
                  onChange={(val) => setFechaDesde(val)}
                  placeholder="dd-mm-aaaa"
                />
              </div>
              <div className="documentos-filter">
                <label className="form-label">Hasta</label>
                <DateInput
                  value={fechaHasta}
                  onChange={(val) => setFechaHasta(val)}
                  placeholder="dd-mm-aaaa"
                />
              </div>
              {user?.rol === 'administrador' && comunidades.length > 0 && (
                <div className="documentos-filter">
                  <label className="form-label">Comunidad</label>
                  <select
                    className="form-control"
                    value={filtroComunidad}
                    onChange={(e) => setFiltroComunidad(e.target.value)}
                  >
                    <option value="">Todas</option>
                    {comunidades.map(c => (
                      <option key={c.id} value={c.id}>{c.nombre}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          </div>
        )}
      </section>

      {loading ? (
        <div className="documentos-skeleton-list">
          {[1, 2, 3, 4, 5].map((item) => (
            <div key={item} className="documentos-skeleton"></div>
          ))}
        </div>
      ) : documentosFiltrados.length === 0 ? (
        <EmptyState
          icon="📂"
          title={filtroCategoria ? 'No hay documentos en esta categoría' : 'No hay documentos disponibles'}
          message={filtroCategoria 
            ? 'Intenta seleccionar otra categoría o quitar los filtros'
            : 'Cuando se suban documentos aparecerán aquí'}
          action={
            user?.rol === 'administrador' && (
              <Button variant="primary" size="md" onClick={handleOpenModal}>
                + Subir Documento
              </Button>
            )
          }
        />
      ) : (
        <>
          <div className="documentos-feed">
            {documentosFiltradosPaginados.map((doc) => {
              const fileMeta = getFileMeta(doc);
              const isNew = esNuevo(doc.fecha_subida || doc.fecha_creacion);
              return (
                <article
                  key={doc.id}
                  className="documentos-card"
                  onClick={() => handleDownload(doc)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      handleDownload(doc);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <div className="documentos-card-header">
                    <div className="documentos-card-title-group">
                      <div className={`documentos-file-icon documentos-file-icon--${fileMeta.kind}`}>
                        {fileMeta.label}
                      </div>
                      <h3 className="documentos-card-title">{doc.nombre}</h3>
                      {isNew && <span className="documentos-new">Nuevo</span>}
                    </div>
                    {doc.categoria && (
                      <span className="documentos-tag">{getCategoriaLabel(doc.categoria)}</span>
                    )}
                  </div>

                  {doc.descripcion && (
                    <p className="documentos-card-description">{doc.descripcion}</p>
                  )}

                  <div className="documentos-card-footer">
                    <div className="documentos-card-meta">
                      {(doc.fecha_subida || doc.fecha_creacion) && (
                        <span className="documentos-card-meta-item">
                          {new Date(doc.fecha_subida || doc.fecha_creacion).toLocaleDateString('es-ES')}
                        </span>
                      )}
                      {doc.tamano && (
                        <span className="documentos-card-meta-item">{formatBytes(doc.tamano)}</span>
                      )}
                    </div>
                    <div className="documentos-card-actions" onClick={(e) => e.stopPropagation()}>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={(e) => { e.stopPropagation(); abrirPreview(doc); }}
                      >
                        👁️ Ver
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleDownload(doc)}
                      >
                        Descargar
                      </Button>
                      {user?.rol === 'administrador' && (
                        <>
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={(e) => { e.stopPropagation(); setDocParaEditar(doc); setEditNombre(doc.nombre); setEditDescripcion(doc.descripcion || ''); }}
                          >
                            ✏️ Editar
                          </Button>
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={(e) => { e.stopPropagation(); setDocParaEnviar(doc); setResultadoEnvio(null); }}
                          >
                            ✉️ Enviar
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEliminar(doc.id);
                            }}
                          >
                            Eliminar
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                </article>
              );
            })}
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            itemsPerPage={itemsPerPage}
            totalItems={documentosFiltrados.length}
            onPageChange={setCurrentPage}
            onItemsPerPageChange={setItemsPerPage}
          />
        </>
      )}

      {/* Modal para subir documento */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(15, 23, 42, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflowY: 'auto',
          zIndex: 1000,
          backdropFilter: 'blur(8px)',
          padding: '24px 16px'
        }} onClick={() => setShowModal(false)}>
          <div
            style={{
              background: '#ffffff',
              borderRadius: 'var(--radius-xl)',
              padding: 'var(--space-6)',
              maxWidth: '500px',
              width: '100%',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-4)' }}>
              <h2 style={{ fontSize: 'var(--font-2xl)', fontWeight: '700', margin: 0 }}>Subir Documento</h2>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer'
                }}
              >
                ✖️
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 'var(--space-4)' }}>
                <label className="form-label">Nombre del Documento</label>
                <input
                  type="text"
                  className="form-control"
                  value={nuevoDoc.nombre}
                  onChange={(e) => setNuevoDoc({ ...nuevoDoc, nombre: e.target.value })}
                  required
                />
              </div>

              <div style={{ marginBottom: 'var(--space-4)' }}>
                <label className="form-label">Descripción (opcional)</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={nuevoDoc.descripcion}
                  onChange={(e) => setNuevoDoc({ ...nuevoDoc, descripcion: e.target.value })}
                />
              </div>

              <div style={{ marginBottom: 'var(--space-4)' }}>
                <label className="form-label">Categoría</label>
                <select
                  className="form-control"
                  value={nuevoDoc.categoria}
                  onChange={(e) => setNuevoDoc({ ...nuevoDoc, categoria: e.target.value })}
                  required
                >
                  <option value="">Seleccionar categoría</option>
                  {Object.entries(categorias).map(([key, cat]) => (
                    <option key={key} value={key}>{cat.icon} {cat.label}</option>
                  ))}
                </select>
              </div>

              {(user.rol === 'administrador') && comunidades.length > 0 && (
                <div style={{ marginBottom: 'var(--space-4)' }}>
                  <label className="form-label">Comunidad</label>
                  <select
                    className="form-control"
                    value={nuevoDoc.comunidad_id}
                    onChange={(e) => setNuevoDoc({ ...nuevoDoc, comunidad_id: e.target.value })}
                    required
                  >
                    <option value="">— Seleccionar comunidad —</option>
                    {comunidades.map(c => (
                      <option key={c.id} value={c.id}>{c.nombre}</option>
                    ))}
                  </select>
                </div>
              )}

              <div style={{ marginBottom: 'var(--space-4)' }}>
                <label className="form-label">Archivo</label>
                <div
                  onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
                  onDragLeave={() => setIsDragging(false)}
                  onDrop={(e) => {
                    e.preventDefault();
                    setIsDragging(false);
                    const file = e.dataTransfer.files[0];
                    if (file) setNuevoDoc(prev => ({ ...prev, archivo: file }));
                  }}
                  style={{
                    border: `2px dashed ${isDragging ? '#2563EB' : 'var(--primary)'}`,
                    borderRadius: 'var(--radius-button)',
                    padding: 'var(--space-4)',
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    background: isDragging ? 'rgba(37,99,235,0.08)' : nuevoDoc.archivo ? 'var(--bg-light)' : 'transparent'
                  }}>
                  <input
                    type="file"
                    onChange={(e) => setNuevoDoc({ ...nuevoDoc, archivo: e.target.files[0] })}
                    style={{ display: 'none' }}
                    id="file-input"
                  />
                  <label htmlFor="file-input" style={{ cursor: 'pointer', display: 'block' }}>
                    <span style={{ fontSize: '24px', display: 'block', marginBottom: '8px' }}>📄</span>
                    <span style={{ fontWeight: '600' }}>
                      {nuevoDoc.archivo ? nuevoDoc.archivo.name : 'Haz clic para seleccionar o arrastra un archivo'}
                    </span>
                  </label>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 'var(--space-3)' }}>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={loadingSave || !nuevoDoc.nombre || !nuevoDoc.archivo || (user.rol === 'administrador' && !nuevoDoc.comunidad_id)}
                  style={{ flex: 1 }}
                >
                  {loadingSave ? 'Subiendo...' : 'Subir'}
                </Button>
                <Button
                  variant="ghost"
                  onClick={() => setShowModal(false)}
                  style={{ flex: 1 }}
                >
                  Cancelar
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Modal subida masiva */}
      {showBulkModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', overflowY: 'auto', zIndex: 1000, backdropFilter: 'blur(8px)', padding: '24px 16px' }}
          onClick={() => !bulkProgress && setShowBulkModal(false)}>
          <div style={{ background: '#fff', borderRadius: 'var(--radius-xl)', padding: 'var(--space-6)', width: '100%', maxWidth: '620px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}
            onClick={e => e.stopPropagation()}>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-4)' }}>
              <h2 style={{ fontSize: 'var(--font-2xl)', fontWeight: '700', margin: 0 }}>Subida masiva</h2>
              {!bulkProgress && (
                <button onClick={() => setShowBulkModal(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>✖️</button>
              )}
            </div>

            {/* Selector comunidad (admin) */}
            {user?.rol === 'administrador' && comunidades.length > 0 && (
              <div style={{ marginBottom: 'var(--space-4)' }}>
                <label className="form-label">Comunidad (para todos los documentos)</label>
                <select className="form-control" value={bulkComunidadId} onChange={e => setBulkComunidadId(e.target.value)} required disabled={!!bulkProgress}>
                  <option value="">— Seleccionar comunidad —</option>
                  {comunidades.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                </select>
              </div>
            )}

            {/* Drop zone */}
            {!bulkProgress && (
              <div style={{ marginBottom: 'var(--space-4)' }}>
                <input type="file" multiple id="bulk-file-input" style={{ display: 'none' }} onChange={handleBulkFileChange} />
                <label htmlFor="bulk-file-input" style={{ cursor: 'pointer', border: '2px dashed var(--primary)', borderRadius: 'var(--radius-button)', padding: 'var(--space-5)', textAlign: 'center', display: 'block' }}>
                  <span style={{ fontSize: '32px', display: 'block', marginBottom: '8px' }}>📂</span>
                  <span style={{ fontWeight: '600', display: 'block' }}>Haz clic para seleccionar archivos</span>
                  <span style={{ display: 'block', fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>
                    Navega hasta la carpeta que quieras y selecciona los archivos con <strong>Ctrl+clic</strong>
                  </span>
                  <span style={{ display: 'block', fontSize: '12px', color: '#9ca3af', marginTop: '4px' }}>PDF, Word, Excel, ZIP, imágenes — hasta 200 MB por archivo</span>
                </label>
              </div>
            )}

            {/* Lista de ficheros */}
            {bulkFiles.length > 0 && !bulkProgress && (
              <div style={{ marginBottom: 'var(--space-4)' }}>
                <p style={{ fontWeight: '600', marginBottom: '8px' }}>{bulkFiles.length} archivo{bulkFiles.length > 1 ? 's' : ''} seleccionado{bulkFiles.length > 1 ? 's' : ''}:</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '280px', overflowY: 'auto' }}>
                  {bulkFiles.map((item, idx) => (
                    <div key={idx} style={{ display: 'flex', gap: '8px', alignItems: 'center', background: '#f8fafc', borderRadius: '8px', padding: '8px 10px' }}>
                      <span style={{ fontSize: '18px' }}>📄</span>
                      <input
                        className="form-control"
                        style={{ flex: 2, fontSize: '13px', padding: '4px 8px' }}
                        value={item.nombre}
                        onChange={e => updateBulkFile(idx, 'nombre', e.target.value)}
                        placeholder="Nombre del documento"
                      />
                      <select
                        className="form-control"
                        style={{ flex: 1, fontSize: '13px', padding: '4px 8px' }}
                        value={item.categoria}
                        onChange={e => updateBulkFile(idx, 'categoria', e.target.value)}
                      >
                        {Object.entries(categorias).map(([key, cat]) => (
                          <option key={key} value={key}>{cat.label}</option>
                        ))}
                      </select>
                      <button onClick={() => removeBulkFile(idx)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '16px', padding: '0 4px' }}>✕</button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Barra de progreso */}
            {bulkProgress && (
              <div style={{ marginBottom: 'var(--space-4)' }}>
                <p style={{ fontWeight: '600', marginBottom: '8px' }}>
                  Subiendo... {bulkProgress.current} / {bulkProgress.total}
                </p>
                <div style={{ background: '#e5e7eb', borderRadius: '99px', height: '10px', overflow: 'hidden' }}>
                  <div style={{ background: 'var(--primary)', height: '100%', borderRadius: '99px', width: `${(bulkProgress.current / bulkProgress.total) * 100}%`, transition: 'width 0.3s ease' }} />
                </div>
                {bulkProgress.errors.length > 0 && (
                  <div style={{ marginTop: '8px' }}>
                    <p style={{ color: '#ef4444', fontSize: '13px', fontWeight: '600', marginBottom: '4px' }}>
                      Archivos con error:
                    </p>
                    {bulkProgress.errors.map((e, i) => (
                      <p key={i} style={{ color: '#ef4444', fontSize: '12px', margin: '2px 0' }}>
                        ✕ <strong>{e.nombre}</strong> — {e.motivo}
                      </p>
                    ))}
                  </div>
                )}
                {bulkProgress.current === bulkProgress.total && (
                  <p style={{ color: '#22c55e', fontWeight: '600', marginTop: '8px' }}>
                    ✅ Completado
                  </p>
                )}
              </div>
            )}

            {/* Botones */}
            {!bulkProgress && (
              <div style={{ display: 'flex', gap: 'var(--space-3)' }}>
                <Button
                  variant="primary"
                  style={{ flex: 1 }}
                  disabled={bulkFiles.length === 0 || (user?.rol === 'administrador' && !bulkComunidadId)}
                  onClick={handleBulkSubmit}
                >
                  Subir {bulkFiles.length > 0 ? `${bulkFiles.length} archivo${bulkFiles.length > 1 ? 's' : ''}` : 'archivos'}
                </Button>
                <Button variant="ghost" style={{ flex: 1 }} onClick={() => setShowBulkModal(false)}>Cancelar</Button>
              </div>
            )}
          </div>
        </div>
      )}

      <ConfirmModal
        isOpen={confirmModal.isOpen}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={confirmModal.onConfirm}
        onCancel={closeConfirm}
        confirmLabel="Eliminar"
        variant="danger"
      />

      {/* Modal: previsualización de documento */}
      {docParaPreview && (() => {
        const fileMeta = getFileMeta(docParaPreview);
        const esPDF = fileMeta.kind === 'pdf';
        const esImagen = fileMeta.kind === 'image';
        return (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15,23,42,0.85)', display: 'flex', flexDirection: 'column', zIndex: 1100, backdropFilter: 'blur(4px)' }}
            onClick={cerrarPreview}>
            {/* Barra superior */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', background: 'rgba(0,0,0,0.4)', flexShrink: 0 }}
              onClick={e => e.stopPropagation()}>
              <span style={{ color: 'white', fontWeight: '600', fontSize: '15px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 'calc(100% - 120px)' }}>
                {docParaPreview.nombre}
              </span>
              <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
                <button onClick={() => handleDownload(docParaPreview)}
                  style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', borderRadius: '8px', padding: '6px 14px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                  Descargar
                </button>
                <button onClick={cerrarPreview}
                  style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', borderRadius: '8px', padding: '6px 14px', cursor: 'pointer', fontSize: '18px', lineHeight: 1 }}>
                  ✕
                </button>
              </div>
            </div>
            {/* Contenido */}
            <div style={{ flex: 1, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px' }}
              onClick={e => e.stopPropagation()}>
              {loadingPreview && (
                <div style={{ textAlign: 'center', color: 'white' }}>
                  <p style={{ fontSize: '32px', marginBottom: '12px' }}>⏳</p>
                  <p style={{ fontSize: '14px' }}>Cargando vista previa...</p>
                </div>
              )}
              {!loadingPreview && previewBlobUrl && esPDF && (
                <iframe
                  src={previewBlobUrl}
                  title={docParaPreview.nombre}
                  style={{ width: '100%', height: '100%', border: 'none', borderRadius: '8px', background: 'white' }}
                />
              )}
              {!loadingPreview && previewBlobUrl && esImagen && (
                <img
                  src={previewBlobUrl}
                  alt={docParaPreview.nombre}
                  style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: '8px' }}
                />
              )}
              {!loadingPreview && (!previewBlobUrl || (!esPDF && !esImagen)) && (
                <div style={{ textAlign: 'center', color: 'white' }}>
                  <p style={{ fontSize: '48px', marginBottom: '16px' }}>📄</p>
                  <p style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>{docParaPreview.nombre}</p>
                  <p style={{ fontSize: '13px', color: '#94a3b8', marginBottom: '24px' }}>Este tipo de archivo no se puede previsualizar</p>
                  <button onClick={() => handleDownload(docParaPreview)}
                    style={{ background: '#2563eb', color: 'white', border: 'none', borderRadius: '10px', padding: '12px 24px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>
                    Descargar archivo
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* Modal: editar nombre y descripción del documento */}
      {docParaEditar && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', overflowY: 'auto', zIndex: 1000, backdropFilter: 'blur(8px)', padding: '12vh 16px 24px' }}
          onClick={() => !loadingEdit && setDocParaEditar(null)}>
          <div style={{ background: '#fff', borderRadius: 'var(--radius-xl)', padding: 'var(--space-6)', width: '100%', maxWidth: '460px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}
            onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700' }}>✏️ Editar documento</h2>
              <button onClick={() => setDocParaEditar(null)} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer' }}>✖️</button>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <label className="form-label">Nombre</label>
              <input
                className="form-control"
                value={editNombre}
                onChange={e => setEditNombre(e.target.value)}
                autoFocus
                onKeyDown={e => e.key === 'Enter' && handleGuardarEdicion()}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label className="form-label">Descripción (opcional)</label>
              <textarea
                className="form-control"
                rows="3"
                value={editDescripcion}
                onChange={e => setEditDescripcion(e.target.value)}
              />
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button variant="primary" style={{ flex: 1 }} disabled={loadingEdit || !editNombre.trim()} onClick={handleGuardarEdicion}>
                {loadingEdit ? 'Guardando...' : 'Guardar'}
              </Button>
              <Button variant="ghost" style={{ flex: 1 }} disabled={loadingEdit} onClick={() => setDocParaEditar(null)}>
                Cancelar
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: gestión de propietarios externos */}
      {showPropietariosModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', overflowY: 'auto', zIndex: 1000, backdropFilter: 'blur(8px)', padding: '24px 16px' }}
          onClick={() => setShowPropietariosModal(false)}>
          <div style={{ background: '#fff', borderRadius: 'var(--radius-xl)', padding: 'var(--space-6)', width: '100%', maxWidth: '620px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', margin: 'auto' }}
            onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700' }}>Propietarios externos</h2>
              <button onClick={() => setShowPropietariosModal(false)} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer' }}>✖️</button>
            </div>
            <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '16px', lineHeight: '1.5' }}>
              Añade los emails de los propietarios que recibirán documentos por email (aunque no estén registrados en HabitaPro).
            </p>

            {comunidades.length > 0 && (
              <div style={{ marginBottom: '16px' }}>
                <label className="form-label">Comunidad</label>
                <select className="form-control" value={propietariosComunidadId}
                  onChange={e => { setPropietariosComunidadId(e.target.value); cargarPropietarios(e.target.value); setEmailInput(''); setEmailsBulk(''); }}>
                  <option value="">— Seleccionar comunidad —</option>
                  {comunidades.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                </select>
              </div>
            )}

            {propietariosComunidadId && (
              <>
                <div style={{ marginBottom: '12px' }}>
                  <label className="form-label">Añadir email</label>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="correo@ejemplo.com"
                      value={emailInput}
                      onChange={e => setEmailInput(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleAnadirUno(); } }}
                      disabled={loadingAnadir}
                      style={{ flex: 1 }}
                    />
                    <Button variant="primary" size="md" onClick={handleAnadirUno} disabled={loadingAnadir || !emailInput.trim()}>
                      Añadir
                    </Button>
                  </div>
                </div>

                <div style={{ position: 'relative', textAlign: 'center', fontSize: '12px', color: '#9ca3af', margin: '12px 0' }}>
                  <div style={{ position: 'absolute', top: '50%', left: 0, right: 0, height: '1px', background: '#e5e7eb' }}></div>
                  <span style={{ position: 'relative', background: '#fff', padding: '0 10px' }}>o pega varios a la vez</span>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <textarea
                    className="form-control"
                    placeholder={'raul@ejemplo.com\njuan@ejemplo.com\nmaria@ejemplo.com'}
                    value={emailsBulk}
                    onChange={e => setEmailsBulk(e.target.value)}
                    rows={3}
                    disabled={loadingAnadir}
                    style={{ resize: 'vertical', fontFamily: 'monospace', fontSize: '13px', marginBottom: '8px' }}
                  />
                  <Button variant="secondary" size="md" onClick={handleAnadirBulk} disabled={loadingAnadir || !emailsBulk.trim()} style={{ width: '100%' }}>
                    {loadingAnadir ? 'Añadiendo...' : 'Añadir todos'}
                  </Button>
                </div>

                <div style={{ marginBottom: '8px', fontWeight: '600', fontSize: '14px' }}>
                  {loadingPropietarios ? 'Cargando...' : `${propietariosLista.length} propietario${propietariosLista.length !== 1 ? 's' : ''} en la lista`}
                </div>

                {propietariosLista.length > 0 && (
                  <div style={{ maxHeight: '260px', overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                    {propietariosLista.map(p => (
                      <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', borderBottom: '1px solid #f1f5f9' }}>
                        <span style={{ flex: 1, fontSize: '13px' }}>{p.email}</span>
                        <button onClick={() => handleEliminarPropietario(p.id)}
                          style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '16px', padding: '2px 4px' }}>✕</button>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* Modal: confirmar y enviar documento a propietarios */}
      {docParaEnviar && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, backdropFilter: 'blur(8px)', overflowY: 'auto', padding: '24px 16px' }}
          onClick={() => !loadingEnvio && setDocParaEnviar(null)}>
          <div style={{ background: '#fff', borderRadius: 'var(--radius-xl)', padding: 'var(--space-6)', width: '100%', maxWidth: '480px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', margin: 'auto' }}
            onClick={e => e.stopPropagation()}>
            <h2 style={{ margin: '0 0 12px', fontSize: '20px', fontWeight: '700' }}>✉️ Enviar documento por email</h2>
            <p style={{ fontSize: '14px', color: '#374151', marginBottom: '8px' }}>
              Se enviará <strong>{docParaEnviar.nombre}</strong> a todos los propietarios:
            </p>
            <ul style={{ fontSize: '13px', color: '#6b7280', paddingLeft: '20px', marginBottom: '20px', lineHeight: '1.7' }}>
              <li>Propietarios externos añadidos a la lista de esta comunidad</li>
            </ul>

            {resultadoEnvio ? (
              <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px', padding: '14px 16px', marginBottom: '16px', textAlign: 'center' }}>
                <p style={{ fontSize: '22px', margin: '0 0 4px' }}>✅</p>
                <p style={{ fontWeight: '700', color: '#166534', margin: '0 0 4px' }}>Emails enviados</p>
                <p style={{ fontSize: '13px', color: '#4b5563', margin: 0 }}>
                  {resultadoEnvio.enviados} enviados correctamente
                  {resultadoEnvio.errores > 0 && <span style={{ color: '#ef4444' }}> · {resultadoEnvio.errores} con error</span>}
                </p>
              </div>
            ) : (
              <div style={{ display: 'flex', gap: '10px' }}>
                <Button variant="primary" style={{ flex: 1 }} disabled={loadingEnvio} onClick={handleEnviarDocumento}>
                  {loadingEnvio ? 'Enviando...' : 'Confirmar envío'}
                </Button>
                <Button variant="ghost" style={{ flex: 1 }} disabled={loadingEnvio} onClick={() => setDocParaEnviar(null)}>
                  Cancelar
                </Button>
              </div>
            )}
            {resultadoEnvio && (
              <Button variant="ghost" style={{ width: '100%', marginTop: '8px' }} onClick={() => setDocParaEnviar(null)}>Cerrar</Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Documentos;
